import React, { useRef } from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

import DragHandle from 'components/DragHandle';

const Handle = SortableHandle(() => <DragHandle />);

const SortableListItem = SortableElement(({ children }) => (
  <div className="sortable-list__item" style={{ marginBottom: '8px' }}>
    {children}
  </div>
));

const SortContainer = SortableContainer(({ children }) => (
  <div>{children}</div>
));

const SortableList = ({ children, ...rest }) => {
  const ref = useRef();

  return (
    <div className="sortable-list" ref={ref}>
      <SortContainer helperContainer={() => ref.current} useDragHandle lockAxis="y" {...rest}>
        {children}
      </SortContainer>
    </div>
  );
};

SortableList.Item = SortableListItem;
SortableList.Handle = Handle;

export default SortableList;
